module.exports = __webpack_public_path__ + "static/media/UBC.cd7628f0.png";